"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGetMoveState = void 0;
function createGetMoveState(count) {
    return (s, mx = 0) => {
        const dir = mx === 0 ? s.dir : mx < 0 ? 1 : -1;
        const targetIndex = mx !== 0 ? (s.curr + dir + count) % count : -1;
        return {
            dir,
            targetIndex,
        };
    };
}
exports.createGetMoveState = createGetMoveState;
//# sourceMappingURL=createGetMoveState.js.map